import {
  TeacherMiniCardViewQuery,
  useTeacherMiniCardViewQuery,
} from 'core/graphql';

/** Мини-карточка преподавателя (ТЗ 0122): группы, ближайшее занятие, рейтинг. */
export type ITeacherMiniCard = NonNullable<
  TeacherMiniCardViewQuery['teacherMiniCard']
>;

/**
 * Карточка «кто это» для преподавателя — как `useStudentMiniCard`: запрос
 * откладывается до открытия (`skip`), `cache-first` — повторное наведение
 * без запроса. `null` без ошибки — роли карточку не видно.
 */
export const useTeacherMiniCard = (
  teacherId?: string,
  options?: { skip?: boolean },
) => {
  const { data, loading, error, refetch } = useTeacherMiniCardViewQuery({
    variables: { teacherId: teacherId || '' },
    skip: !teacherId || options?.skip,
    fetchPolicy: 'cache-first',
  });
  return {
    card: data?.teacherMiniCard ?? null,
    loading,
    failed: Boolean(error),
    refetch: () => {
      refetch().catch(() => undefined);
    },
  };
};
